import * as ActionType from "../actionType";
import { fetchHighlightshowPageApi } from "../../services/page/highlightshowpage";

const getHighlightshowPageAction = () => {
  return async dispatch => {
    dispatchHighlightshowPage(dispatch);
  };
};

const dispatchHighlightshowPage = dispatch => {
  fetchHighlightshowPageApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_HIGHLIGHTSHOW_PAGE,
      data
    });
  });
};

export { getHighlightshowPageAction, dispatchHighlightshowPage };



// WEBPACK FOOTER //
// ./src/actions/page/highlightshowpage.js